import { Suspense } from "react";
import styled from "styled-components";

import { useDialog } from "~/src/modules/ui-kit";

import BIMClassCardContainer from "./BIMClassCardContainer";
import BIMClassFinderPlugin from "./BIMClassFinderPlugin";
import { Finder2 as Finder } from "../../../../../../modules/finder";
import * as UI from "../../../../../../modules/ui-kit";


const Styled = styled.div`
    align-items: flex-end;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
`;

export default function BIMClassSelector(props) {
    const { disabled, onChange, value } = props;

    const [Dialog, open, close] = useDialog();

    function onSelect(bimClass) {
        onChange(bimClass);
        close();
    }

    return (
        <Styled>
            {
                value && (
                    <Suspense fallback={ <UI.Bone height="1.6rem" width="16rem" /> }>
                        <BIMClassCardContainer
                            id={ value }
                        />
                    </Suspense>
                )
            }
            <UI.Button
                $size="large"
                disabled={ disabled }
                onClick={ open }
            >
                { value ? "Change" : "Select" } BIMClass
            </UI.Button>
            <Dialog>
                <Finder placeholder="Search for a BIMClass">
                    <BIMClassFinderPlugin
                        onSelect={ onSelect }
                    />
                </Finder>
            </Dialog>
        </Styled>
    );
}
